"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMatrizMateria = exports.yupMatrizMateria = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupMatrizMateria = yup.object({
    idMatrizCurricular: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Matriz Curricular'),
    sequencia: yup.string().default('').required().max(2).label('Sequência'),
    nomeMateria: yup.string().default('').required().max(100).label('Nome Matéria'),
    nomeAbreviado: yup.string().default('').required().max(4).label('Nome Matéria Abreviado'),
    areaMateria: yup
        .mixed()
        .oneOf(Object.values(enums_1.EMateriaGrupo))
        .default(enums_1.EMateriaGrupo['Base Nacional Comum'])
        .label('Area da Matéria'),
    organizacaoCurricular: yup
        .mixed()
        .oneOf(Object.values(enums_1.EMateriaOrg))
        .notRequired()
        .label('Organização Curricular'),
    tipoCarga: yup.string().default('').max(1).label('Tipo Carga'),
    carga1: yup.number().default(0).label('Carga Horária 1'),
    carga2: yup.number().default(0).label('Carga Horária 2'),
    carga3: yup.number().default(0).label('Carga Horária 3'),
    carga4: yup.number().default(0).label('Carga Horária 4'),
    carga5: yup.number().default(0).label('Carga Horária 5'),
    carga6: yup.number().default(0).label('Carga Horária 6'),
    carga7: yup.number().default(0).label('Carga Horária 7'),
    carga8: yup.number().default(0).label('Carga Horária 8'),
    carga9: yup.number().default(0).label('Carga Horária 9'),
    cargaTotal: yup.number().default(0).label('Total Carga Horária'),
    aula1: yup.number().default(0).label('Duração Aula 1'),
    aula2: yup.number().default(0).label('Duração Aula 2'),
    aula3: yup.number().default(0).label('Duração Aula 3'),
    aula4: yup.number().default(0).label('Duração Aula 4'),
    aula5: yup.number().default(0).label('Duração Aula 5'),
    aula6: yup.number().default(0).label('Duração Aula 6'),
    aula7: yup.number().default(0).label('Duração Aula 7'),
    aula8: yup.number().default(0).label('Duração Aula 8'),
    aula9: yup.number().default(0).label('Duração Aula 9'),
    horaTotal: yup.number().default(0).label('Total Duração Aula'),
    asterisco1: yup.string().default('').max(5).label('Asterisco 1'),
    asterisco2: yup.string().default('').max(5).label('Asterisco 2'),
    asterisco3: yup.string().default('').max(5).label('Asterisco 3'),
    asterisco4: yup.string().default('').max(5).label('Asterisco 4'),
    asterisco5: yup.string().default('').max(5).label('Asterisco 5'),
    asterisco6: yup.string().default('').max(5).label('Asterisco 6'),
    asterisco7: yup.string().default('').max(5).label('Asterisco 7'),
    asterisco8: yup.string().default('').max(5).label('Asterisco 8'),
    asterisco9: yup.string().default('').max(5).label('Asterisco 9'),
    somaCarga: yup.boolean().required().default(false).label('Somar a Carga Horária'),
    matrizMateriaGrade: yup.array().default([]),
});
exports.schemaMatrizMateria = exports.yupMatrizMateria.shape({});
